<template>
  <div class="inline-flex h-6 text-sm font-medium leading-none rounded-md">
    <div class="flex items-center justify-center overflow-hidden rounded-l-md">
      <slot name="prefix" />
    </div>
    <div class="flex items-center px-2 tracking-snug">
      <slot />
    </div>
    <div class="flex items-center justify-center overflow-hidden rounded-r-md">
      <slot name="suffix" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Badge'
}
</script>